<kt-portlet>
    <kt-portlet-header [class]="'kt-portlet-head--lg'" [viewLoading$]="dataSource.loading$"
                       [tooltipTitle]="'TOOLTIP.AUDIT_TRAIL.LIST.TITLE' | translate"
                       [tooltipDesc]="'TOOLTIP.AUDIT_TRAIL.LIST.DESCRIPTION' | translate">
        <!-- PORTLET LOADING | Binded to TABLE Datasource -->

        <ng-container ktPortletTitle>
            <h3 class="kt-portlet-head-title">
                <span>
                    {{ 'AUDIT_TRAIL.LIST.TITLE' | translate:{assignment_name: (assignment ? assignment.name : '')} }}
                </span>
            </h3>
            <!-- For localisations we use @ngx-translate | See off. documentations => https://github.com/ngx-translate/core -->
            <!-- Localization libraries (en/fr) are here => '../../../.././config/i18n/en.ts|fr.ts' -->
        </ng-container>

        <ng-container ktPortletTools>
            <a (click)="back()" class="btn mr-2" mat-raised-button
               [matTooltip]="backTitle">
                <mat-icon>arrow_back</mat-icon>
                <span class="kt-hidden-mobile">
                    {{ 'GENERAL.BUTTON.BACK' | translate }}
                </span>
            </a>
            <kt-context-menu-mad
                    [(menuItems)]="menuItems"
                    [(menuSubject)]="menuSubject"
                    [width]="'200'">
            </kt-context-menu-mad>

            <button
                    class="ml-2 button-gray"
                    *ngIf="trashCnt != 0"
                    (click)="trash()"
                    mat-raised-button
                    [matTooltip]="'AUDIT_TRAIL.LIST.BUTTON.TRASHED.TOOLTIP' | translate"
                    type="button">
                <span>{{ 'GENERAL.BUTTON.TRASHED' | translate }} ({{trashCnt}})</span>
            </button>

            <!--<button *ngIf="adminTrashCnt != 0"-->
            <!--(click)="adminTrash()"-->
            <!--mat-raised-button-->
            <!--matTooltip="Deleted Audit Trails"-->
            <!--type="button"-->
            <!--class="button-gray ml-2">-->
            <!--<span>Admin Trashed ({{adminTrashCnt }})</span>-->
            <!--</button>-->
        </ng-container>
    </kt-portlet-header>
    <!-- end::Header -->

    <kt-portlet-body>
        <!-- start::FILTERS & GROUP ACTIONS -->
        <div class="kt-form">
            <!-- start::FILTERS -->
            <div class="kt-form-filtration">
                <div class="row align-items-center active">
                    <div class="col-md-2 kt-margin-bottom-10-mobile">
                        <!-- 'm  margin-bottom-10-mobile' for adaptive make-up  -->
                        <div class="kt-form-control">
                            <mat-form-field class="mat-form-field-fluid">
                                <mat-select [(value)]="filterToE" (selectionChange)="valueChange()">
                                    <mat-option value="">{{ 'AUDIT_TRAIL.LIST.FILTER.TOE.VALUE.ALL' | translate }}</mat-option>
                                    <mat-option value="0"> {{ 'AUDIT_TRAIL.LIST.FILTER.TOE.VALUE.GENERAL' | translate }}</mat-option>
                                    <mat-option value="{{toe.id}}" *ngFor="let toe of toes;">{{toe.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                </div>
            </div>
            <!-- end::FILTERS -->

            <!-- start::GROUP ACTIONS -->
            <!-- end::GROUP ACTIONS -->
        </div>
        <!-- end::FILTERS & GROUP ACTIONS -->

        <!-- MATERIAL TABLE | Binded to datasources -->
        <!-- See off.documentations 'https://material.angular.io/components/table/overview' -->
        <div class="mat-table-wrapper">
            <mat-table class="lmat-elevation-z8 table-striped"
                       #table
                       [dataSource]="dataSource"
                       matSort
                       #sort1="matSort"
                       matSortActive="created_at"
                       matSortDirection="desc"
                       matSortDisableClear>

                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>#</mat-header-cell>
                    <mat-cell
                            *matCellDef="let auditTrail">{{auditTrail.ref_num}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ref">
                    <mat-header-cell *matHeaderCellDef>ref</mat-header-cell>
                    <mat-cell *matCellDef="let auditTrail">
                        {{ auditTrail.ref }}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="interaction_date">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.INTERACTION_DATE' | translate }}
                    </mat-header-cell>
                    <mat-cell
                            *matCellDef="let auditTrail">{{currentUser && auditTrail.interaction_date | date: 'dd MMM yyyy':currentUser.settings.time_zone_gmt}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="client_name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.CLIENT' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let auditTrail">{{auditTrail.client_name}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="terms_of_engagement_name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.TOE' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let auditTrail">{{auditTrail.terms_of_engagement_name | truncate : ['100']}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="asset_class_name">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.TARGET_PROPERTY' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let auditTrail">{{auditTrail.asset_class_name | truncate : ['100']}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="impact_on_valuation">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.EXPECTED_IMPACT' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let auditTrail">
                        {{auditTrail.impact_on_valuation}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="created_at">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.CREATED_AT' | translate }}
                    </mat-header-cell>
                    <mat-cell
                            *matCellDef="let auditTrail">{{auditTrail.created_at}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef>
                        {{ 'AUDIT_TRAIL.LIST.DATATABLE.ACTIONS' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let auditTrail">
                        <ng-template #popTitle>
                            {{ 'GENERAL.INFORMATION_TOOLTIP.TITLE' | translate }}
                        </ng-template>
                        <ng-template #popContent>
                            <p [innerHTML]="'GENERAL.INFORMATION_TOOLTIP.CREATED_BY' | translate:{
                                    username: auditTrail.createdBy ? auditTrail.createdBy : 'Unknown',
                                    date: (auditTrail.created_at | date: 'dd MMM yyyy':currentUser.settings.time_zone_gmt)
                                }">
                            </p>
                            <div [innerHTML]="'AUDIT_TRAIL.LIST.POP_OVER.INFORMATION.TYPE' | translate:{
                                type: auditTrail.interaction_type_name
                                }">
                            </div>
                        </ng-template>
                        <button mat-icon-button
                                color="primary"
                                [ngbPopover]="popContent"
                                [popoverTitle]="popTitle"
                                *ngIf="currentUser"
                        >
                            <mat-icon
                                [matTooltip]="'GENERAL.TOOLTIP.INFORMATION' | translate"
                            >info</mat-icon>
                        </button>

                        <button mat-icon-button
                                color="warn"
                                [matTooltip]="'AUDIT_TRAIL.LIST.BUTTON.DELETE.TOOLTIP' | translate"
                                type="button"
                                (click)="deleteInteraction(auditTrail)">
                            <mat-icon>delete</mat-icon>
                        </button>&nbsp;
                        <button mat-icon-button
                                [matTooltip]="'AUDIT_TRAIL.LIST.BUTTON.DETAIL.TOOLTIP' | translate"
                                type="button"
                                (click)="reachInteraction(auditTrail)">
                            <mat-icon>remove_red_eye</mat-icon>
                        </button>&nbsp;
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>
            <!-- Message for empty data  -->
            <div class="mat-table-message" *ngIf="!dataSource.hasItems">
                {{ 'GENERAL.MESSAGE.NO_DATA' | translate }}
            </div>
            <div class="mat-table-message" *ngIf="dataSource.isPreloadTextViewed$ | async">
                {{ 'GENERAL.MESSAGE.PLEASE_WAIT' | translate }}
            </div>
        </div>

        <!-- start: BOTTOM -->
        <div class="mat-table-bottom">
            <!-- MATERIAL SPINNER | Url: 'https://material.angular.io/components/progress-spinner/overview' -->
            <mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
            <!-- MATERIAL PAGINATOR | Binded to dasources -->
            <!-- See off.documentations 'https://material.angular.io/components/paginator/overview' -->
            <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100]" [length]="dataSource.paginatorTotal$ | async" [showFirstLastButtons]="true"></mat-paginator>
        </div>
        <!-- end: BOTTOM -->
    </kt-portlet-body>
    <!-- end::Body -->

</kt-portlet>
